var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"mb-5"},[_c('v-col',{staticClass:"p-5 results-box box-shadow",attrs:{"sm":"12","md":"12","lg":"12"}},[_vm._v(" NoServiceTypeResultSingle ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }